module.exports = __webpack_public_path__ + "img/zs_19@2x.0c4fac5c.png";